
export default function CompanyIntroSection() {
  const features = [
    {
      title: '生态茶园',
      description: '拥有5万亩有机认证茶园，坚持生态种植，保护原生态环境',
      icon: 'ri-leaf-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: '古树资源',
      description: '保护和开发百年以上古茶树资源，传承古法制茶工艺',
      icon: 'ri-ancient-gate-line',
      color: 'from-slate-500 to-slate-600'
    },
    {
      title: '现代工艺',
      description: '结合传统制茶技艺与现代科技，确保产品品质稳定',
      icon: 'ri-settings-3-line',
      color: 'from-blue-400 to-blue-500'
    },
    {
      title: '品质追溯',
      description: '建立完善的产品溯源体系，每一片茶叶都有身份证',
      icon: 'ri-qr-code-line',
      color: 'from-gray-500 to-gray-600'
    }
  ];

  return (
    <section id="intro" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/409ab59958780212456ff104d13a64f4.jpg"
              alt="公司介绍"
              className="w-full h-96 object-cover rounded-2xl shadow-lg"
            />
          </div>
          
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
                南滇古茶的使命
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-6">
                南滇古茶成立于2009年，坐落于云南省西双版纳州，是一家集茶叶种植、加工、销售于一体的现代化茶叶企业。我们以"传承千年茶文化，创新现代茶生活"为使命，致力于将云南优质茶叶推向全国乃至世界。
              </p>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                公司拥有专业的茶叶种植基地、现代化的生产加工车间和完善的质量管理体系。我们坚持"源头把控、工艺精湛、品质至上"的经营理念，为消费者提供安全、健康、优质的茶叶产品。
              </p>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-blue-50 rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl font-bold text-blue-600 mb-1">ISO9001</div>
                <div className="text-gray-600 text-xs md:text-sm">质量管理认证</div>
              </div>
              <div className="bg-blue-50 rounded-lg p-4 text-center">
                <div className="text-xl md:text-2xl font-bold text-blue-600 mb-1">有机认证</div>
                <div className="text-gray-600 text-xs md:text-sm">欧盟有机标准</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 group hover:transform hover:scale-105"
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-3">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
